import { Routes } from "@angular/router";
import { full } from "@shared/routes/full.routes";
import { content } from "@shared/routes/routes";
import { ContentComponent } from "./core/layout/content/content.component";
import { FullComponent } from "./core/layout/full/full.component";
import { authGuard } from "./core/services/auth-guard.service";
import { ManagerOnboardingDetailsComponent } from "./merchant-manager-onboarding/manager-onboarding-details/manager-onboarding-details.component";
import { LayoutComponent as RegistrationLayout } from "./registration/layout/layout.component";
import { registrationRoutes } from "./registration/registration-routes";
import { tokenResolver } from "./registration/token-resolver";
import { beforeLoginGuard } from "./auth/guards/before-login.guard";
import { DownloadFileComponent } from "./components/download-file/download-file.component";

export const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "/welcome",
    pathMatch: "full",
  },
  {
    path: "welcome",
    loadComponent: () =>
      import("./auth/components/welcome-page/welcome-page.component").then(
        (com) => com.WelcomePageComponent
      ),
    canActivate: [beforeLoginGuard],
  },
  {
    path: "",
    component: ContentComponent,
    canActivate: [authGuard],
    children: content,
  },
  {
    path: "",
    component: FullComponent,
    children: full,
  },
  {
    path: "registration",
    component: RegistrationLayout,
    children: registrationRoutes,
  },
  {
    path: "merchant-manager-onboarding/:id",
    component: ManagerOnboardingDetailsComponent,
    // children: registrationRoutes
  },

  {
    path: 'downloadfile/:fileId',
    component: DownloadFileComponent
  },
  {
    path: "**",
    loadComponent: () =>
      import("./pages/error/error404/error404.component").then(
        (m) => m.Error404Component
      ),
  },
];
